var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-10 h-10 flex items-center justify-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.$modal.show('log')}}},[_c('img',{staticClass:"w-5 h-4",attrs:{"title":"Aksiyon geçmişini buradan takip edebilirsiniz.","src":require("@/assets/log/logikon.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }